import { createAsyncThunk } from '@reduxjs/toolkit';
import request from '../../request/request';

export const getLicenseDetailAction = createAsyncThunk('licenseDetail', async (object, { rejectWithValue }) => {
  const response = await request(`/api/v1/tenants/details/${object.licenseId}`, { method: 'GET' , auth: true});

  if (response?.data) {
    return response;
  }
  const { error } = response;
  throw rejectWithValue(error || 'Something went wrong');
});